import { 
  PropertyTypeStep,
  BuildingDetailsStep,
  LocationStep,
  AreaStep,
  RenovationLevelStep,
  KeyElementsStep,
  NetworksStep,
  FinishingStep,
  AccessibilityStep,
  ConstraintsStep,
  ResultStep
} from '../steps';

export type QuickStepId = 
  | 'propertyType'
  | 'buildingDetails'
  | 'location'
  | 'area'
  | 'renovationLevel'
  | 'keyElements'
  | 'networks'
  | 'finishing'
  | 'accessibility'
  | 'constraints'
  | 'result';

export interface QuickStep {
  id: QuickStepId;
  title: string;
  description: string;
  component: React.ComponentType<any>;
  condition?: (data: any) => boolean;
}

export const QUICK_STEPS: QuickStep[] = [
  {
    id: 'propertyType',
    title: 'Type de bien',
    description: 'Sélectionnez le type de bien à rénover',
    component: PropertyTypeStep
  },
  {
    id: 'buildingDetails',
    title: 'Détails de l\'immeuble',
    description: 'Informations sur l\'immeuble',
    component: BuildingDetailsStep,
    condition: (data) => data.propertyType === 'building'
  },
  {
    id: 'location',
    title: 'Localisation',
    description: 'Où se situe votre bien ?',
    component: LocationStep
  },
  {
    id: 'area',
    title: 'Surface',
    description: 'Quelle est la surface à rénover ?',
    component: AreaStep
  },
  {
    id: 'renovationLevel',
    title: 'Niveau de rénovation',
    description: 'Quel est le niveau global des travaux ?',
    component: RenovationLevelStep
  },
  {
    id: 'keyElements',
    title: 'Éléments clés',
    description: 'Quels éléments principaux sont à rénover ?',
    component: KeyElementsStep
  },
  {
    id: 'networks',
    title: 'Réseaux',
    description: 'État des réseaux (électricité, plomberie, chauffage)',
    component: NetworksStep
  },
  {
    id: 'finishing',
    title: 'Finitions',
    description: 'Quel niveau de finition souhaitez-vous ?',
    component: FinishingStep
  },
  {
    id: 'accessibility',
    title: 'Accessibilité',
    description: 'Contraintes d\'accès au chantier',
    component: AccessibilityStep
  },
  {
    id: 'constraints',
    title: 'Contraintes',
    description: 'Contraintes particulières du projet',
    component: ConstraintsStep
  },
  {
    id: 'result',
    title: 'Résultat',
    description: 'Estimation des coûts',
    component: ResultStep
  }
];

export const getNextStep = (currentStepId: QuickStepId, data: any): QuickStepId | null => {
  const currentIndex = QUICK_STEPS.findIndex(step => step.id === currentStepId);
  if (currentIndex < QUICK_STEPS.length - 1) {
    // Chercher la prochaine étape valide
    for (let i = currentIndex + 1; i < QUICK_STEPS.length; i++) {
      const nextStep = QUICK_STEPS[i];
      if (!nextStep.condition || nextStep.condition(data)) {
        return nextStep.id;
      }
    }
  }
  return null;
};

export const getPreviousStep = (currentStepId: QuickStepId, data: any): QuickStepId | null => {
  const currentIndex = QUICK_STEPS.findIndex(step => step.id === currentStepId);
  if (currentIndex > 0) {
    // Chercher l'étape précédente valide
    for (let i = currentIndex - 1; i >= 0; i--) {
      const prevStep = QUICK_STEPS[i];
      if (!prevStep.condition || prevStep.condition(data)) {
        return prevStep.id;
      }
    }
  }
  return null;
};